/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import { setEvent } from '../../services'
import {renderMoney, getJsonFromUrl} from '../../utils';

import '../../styles/channel/ChannelPayPanel.css';

const PanelItem = ({title, descri, extraClass, clickMethod}) => (
    <p className="weui-padding text-justify border-line" onClick={clickMethod ? clickMethod : null}>
        {title}
        <span className={"fr " + extraClass}>{descri}</span>
    </p>
);

class ChannelDiscountPanel extends Component {
    render() {
        if (!this.props.discount){
            return null
        }
        const isCoupon = getJsonFromUrl().is_new_coupon == 1
        const fieldName = isCoupon ? '红包' : '优惠券'

        if (isCoupon) {
            setEvent({name: 'wk_channel-show-coupon-panel'})
        } else {
            setEvent({name: 'wk_channel-show-discount-panel'})
        }

        let {money, discount, isCostFix, priceRecordMoney, limitPrice} = this.props;
        money = limitPrice ? limitPrice.price : money
        money = isCostFix ? money : priceRecordMoney
        let realMoney = (money - discount.price > 0) ? (money - discount.price) : 0;
        return (
            <div className="channel-discount-panel">
                <PanelItem title="专栏学费" descri={"￥" + renderMoney(money)}/>
                <PanelItem title="选择优惠" descri={`已使用${fieldName}抵扣￥` + renderMoney(discount.price)} extraClass="money discount__kurisu" clickMethod={() => {
                    this.props.dispatch({
                        type: 'COUPON_SELECT_SHOW'
                    })
                }}/>
                <PanelItem title="还需支付" descri={"￥" + renderMoney(realMoney)} extraClass="money"/>
            </div>
        )
    }
}

export default connect((state) => ({
    money: state.channel.channel.money,
    discount: state.channel.discount,
    isCostFix: state.channel.channel.is_cost_fix,
    priceRecordMoney: state.channel.priceRecordMoney,
    limitPrice: state.channel.channel.promoprice,
}))(ChannelDiscountPanel)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelDiscountPanel.js